export default __webpack_public_path__ + "static/media/escrow_only_logo.adf74d57.svg";